export const ACTIONS = {
  DEACTIVATE_CHAT: 'deactivate-chat',
  ACTIVATE_CHAT: 'activate_chat',
  ACTIVATE_WINDOW: 'activate_window',
  DEACTIVATE_WINDOW: 'deactivate_window',
};
